import { render, staticRenderFns } from "./ApexChartStudentAttendanceRatio.vue?vue&type=template&id=7ef3be94&"
import script from "./ApexChartStudentAttendanceRatio.vue?vue&type=script&lang=js&"
export * from "./ApexChartStudentAttendanceRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports